export default class MarketService {
  getAll() {
    return fetch("https://api.tradersr.com/api/market")
      .then(res => res.json());
  }
}